import { RESET_STATE } from 'store/global/actions';

import { AI_MODELS_ACTION_TYPE } from '../actions/aiModels.actions';

const initialState = [];

const aiModelsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AI_MODELS_ACTION_TYPE.GET_AI_MODELS:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default aiModelsReducer;
